module.exports = __webpack_public_path__ + "static/media/footer.786d3cd5.png";